/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartMakeOfferButton_item$ref: FragmentReference;
export type CartMakeOfferButton_item = {|
  +serviceId: ?string,
  +ecommerceTrackingParams: ?any,
  +$refType: CartMakeOfferButton_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartMakeOfferButton_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ecommerceTrackingParams",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'be6112663d55fd7c0e0b11960597de2f';
module.exports = node;
